import cls from './GetText.module.scss';

type Props = {};

const GetText = ({
  type,
  text,
  size,
  clsname,
}: {
  type: string;
  text: string;
  size: number;
  clsname?: string;
}) => {
  return (
    <div>
      {type === 'h1' && (
        <div className={cls.text}>
          <h1 style={{ fontSize: `${size}px` }} className={cls.second_h1}>
            {text}
          </h1>
          <h1 style={{ fontSize: `${size}px` }} className={cls.first_h1}>
            {text}
          </h1>
        </div>
      )}

      {type === 'h2' && (
        <div className={cls.text}>
          <h2 style={{ fontSize: `${size}px` }} className={cls.second_h2}>
            {text}
          </h2>
          <h2 style={{ fontSize: `${size}px` }} className={cls.first_h2}>
            {text}
          </h2>
        </div>
      )}
    </div>
  );
};

export default GetText;
